import { jsx } from "@ecopages/jsx/jsx-runtime";
import { cx } from "@/lib/cx";
export function RuiButtonGroup({
  children,
  orientation = "horizontal",
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("div", {
    ...props,
    role: "group",
    "aria-orientation": orientation,
    class: cx("rui-button-group", `rui-button-group--${orientation}`, className),
    children
  });
}